module.exports = __webpack_public_path__ + "img/03.7febe456.jpg";